import React from 'react'
import type { MedicalTreatmentsProps } from '@/features/enrollment'
import { medicalTreatmentsOptions } from '../validation/healthLegalValidation'

export default function MedicalTreatments({ enrollmentData, updateEnrollmentData, errors, handleCheckboxChange }: MedicalTreatmentsProps) {
  const selectedTreatments = enrollmentData.medicalTreatments || []
  const selectionCount = selectedTreatments.length
  
  return (
    <div>
      <label className="block text-sm font-medium text-accent-900 mb-2">
        Have you received any of the following medical treatments due to playing video games? <span className="text-red-500">*</span>
      </label>
      
      {/* Selection Counter */}
      <div className="mb-3 p-3 bg-blue-50 border border-blue-200 rounded-lg">
        <p className="text-sm text-blue-800">
          <span className="font-medium">Selection Progress:</span>
          <span className={`ml-2 font-semibold ${selectionCount >= 1 ? 'text-green-600' : 'text-orange-600'}`}>
            {selectionCount} selected (minimum 1 required)
          </span>
        </p>
        <p className="text-xs text-blue-600 mt-1">
          Please select at least 1 medical treatment. "No treatment" is a permitted answer.
        </p>
      </div>
      <div className="grid grid-cols-1 gap-3">
        {medicalTreatmentsOptions.map((treatment) => (
          <label key={treatment} className="flex items-center">
            <input 
              type="checkbox" 
              value={treatment}
              checked={(enrollmentData.medicalTreatments || []).includes(treatment)}
              onChange={(e) => handleCheckboxChange('medicalTreatments', treatment, e.target.checked)}
              className="form-checkbox text-primary-600" 
            />
            <span className="ml-2 text-accent-700">{treatment}</span>
          </label>
        ))}
      </div>
      
      {/* Other Treatment Input */}
      {(enrollmentData.medicalTreatments || []).includes('Other treatment') && (
        <div className="mt-3">
          <label className="block text-sm font-medium text-accent-900 mb-2">Other Treatment:</label>
          <input
            type="text"
            className="input-field w-full"
            placeholder="Specify other treatment"
            value={enrollmentData.otherTreatment || ''}
            onChange={(e) => updateEnrollmentData('otherTreatment', e.target.value)}
          />
        </div>
      )}
      
      {errors.medicalTreatments && (
        <p className="mt-1 text-sm text-red-600">{errors.medicalTreatments}</p>
      )}
    </div>
  )
}
